// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const vaultItemSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  vaultId: z.string().max(100),
  name: z.string().max(500),
  type: z.string().max(200),
  provider: z.string().max(200).optional(),
  encryptedPayload: z.string().max(100000),
  iv: z.string().max(500),
  authTag: z.string().max(500),
  keyWraps: z.array(z.unknown()),
  keyVersion: z.number().int(),
  url: z.string().max(500).optional(),
  tags: z.array(z.string()).optional(),
  notes: z.string().max(5000).optional(),
  expiresAt: z.string().max(200).datetime().optional(),
  lastRotatedAt: z.string().max(200).optional(),
  lastAccessedAt: z.string().max(200).optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type VaultItemInput = z.infer<typeof vaultItemSchema>
